import { adapter, CONTRACTPARTNERS_FEATURE_KEY, ContractPartnersPartialState, ContractPartnersState } from './contractPartners.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const getContractPartnersState = createFeatureSelector<
  ContractPartnersPartialState,
  ContractPartnersState
>(CONTRACTPARTNERS_FEATURE_KEY);

const { selectAll, selectEntities } = adapter.getSelectors();

const getAllContractPartners = createSelector(
  getContractPartnersState,
  selectAll
);

const getAllContractPartnersByUid = createSelector(
  getContractPartnersState,
  selectEntities
);

export const ContractPartnersQuery = {
  getAllContractPartners,
  getAllContractPartnersByUid,
};
